module.exports = __webpack_public_path__ + "img/watch.883bb9ea.svg";